import classNames from "classnames";
import { ReactNode } from "react";

export type BadgeType =
  | "success"
  | "active"
  | "paid"
  | "warning"
  | "error"
  | "canceled"
  | "cancelled"
  | "info"
  | "complete"
  | "completed"
  | "queued"
  | "failed"
  | "processing"
  | "pending"
  | "past_due"
  | "unpaid"
  | "refunded";
export type BadgeColor = "purple" | "red" | "yellow" | "green" | "blue";
export interface BadgeProps {
  type?: BadgeType;
  children: ReactNode;
  className?: string | undefined;
  size?: "sm" | "lg";
  showIndicator?: boolean;
}

export function Badge({
  type,
  children,
  className,
  size = "lg",
  showIndicator = false,
}: BadgeProps) {
  return (
    <span
      className={classNames(
        `inline-flex items-center text-xs rounded-full border border-transparent`,
        {
          "bg-red-100 text-red-800 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/30":
            type === "error" ||
            type === "failed" ||
            type === "canceled" ||
            type === "cancelled" ||
            type === "past_due" ||
            type === "unpaid",
          "bg-yellow-100 text-yellow-800 dark:bg-yellow-500/10 dark:text-yellow-400 dark:border-yellow-500/30":
            type === "warning",
          "bg-green-100 text-green-800 dark:bg-green-500/10 dark:text-green-400 dark:border-green-500/30":
            type === "success" ||
            type === "complete" ||
            type === "completed" ||
            type === "active" ||
            type === "paid",
          "bg-blue-100 text-blue-800 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/30":
            type === "info" || type === "processing" || type === "refunded",
          "bg-muted text-muted-foreground": type === "queued",
        },
        {
          "px-2 leading-5": size !== "lg",
          "px-3 leading-7": size === "lg",
        },
        className,
      )}
    >
      {showIndicator && (
        <svg className="-ml-1 mr-1.5 h-2 w-2" fill="currentColor" viewBox="0 0 8 8">
          <circle cx={4} cy={4} r={3} />
        </svg>
      )}
      {children}
    </span>
  );
}
